import React from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'
import { useTranslation } from '../../hooks'
import get from 'lodash/get'
import { BoxWithLabel } from '../BoxWithLabel'
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers'
import { Dayjs } from 'dayjs'

type DatePickerControllerProps = DatePickerProps<Dayjs> & {
  name: string
  label?: string
  rules?: RegisterOptions
  placeholder?: string
}

const FieldWithController: React.FC<DatePickerControllerProps> = ({
  name,
  rules,
  placeholder,
  ...props
}) => {
  const { t } = useTranslation()

  const {
    formState: { errors },
    control,
  } = useFormContext()

  return (
    <Controller
      rules={{
        ...rules,
        required: rules?.required && t('messages:warnings.required'),
      }}
      render={({ field }) => (
        <DatePicker
          {...field}
          slotProps={{
            textField: {
              fullWidth: true,
              error: !!get(errors, name),
              helperText: get(errors, [name, 'message']) as string,
              placeholder,
            },
          }}
          {...props}
        />
      )}
      name={name}
      control={control}
    />
  )
}

const DatePickerController: React.FC<DatePickerControllerProps> = ({
  label,
  ...props
}) => {
  return label ? (
    <BoxWithLabel label={label} required={!!props.rules?.required}>
      <FieldWithController {...props} />
    </BoxWithLabel>
  ) : (
    <FieldWithController {...props} />
  )
}

export { DatePickerController }
